import script from "./NOAAFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./NOAAFooter.vue?vue&type=script&setup=true&lang=js"

import "./NOAAFooter.vue?vue&type=style&index=0&id=0ef72b5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ef72b5e"]])

export default __exports__